module.exports = __webpack_public_path__ + "img/foot.4f51a6c7.png";